import { getToken } from "@farzoom/common-ui-components";

export const getFile = async (href: string, name?: string) => {
  if (!href) return;

  const response = await fetch(href, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });

  const header = response.headers.get("Content-Disposition");
  const fileName = name ?? extractFilename(header);

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link?.parentNode?.removeChild(link);
};

function extractFilename(contentDisposition: string | null): string {
  if (contentDisposition) {
    const partUtf = contentDisposition
      .split(/;\s*/)
      .find((s) => s.toLowerCase().startsWith("filename*=utf-8''"));
    if (partUtf) {
      return decodeURIComponent(partUtf.substring(17));
    } else {
      const part = contentDisposition
        .split(/;\s*/)
        .find((s) => s.toLowerCase().startsWith("filename="));
      if (part) {
        return part.substring(9).replaceAll('"', "");
      }
    }
  }

  return "defaultName";
}
